import { IOption } from '@netfront/ui-library';

const PAGE_TITLE = 'Reporting';

const TABLE_SELECTION_ITEMS: IOption[] = [
  {
    id: 1,
    value: 'translate-speech-table',
    name: 'Translate & Speech',
  },
  {
    id: 2,
    value: 'pdf-table',
    name: 'PDF',
  },
];

const VIEW_SELECTION_ITEMS: IOption[] = [
  {
    id: 1,
    value: 'sum',
    name: 'Sum daily usage',
  },
  {
    id: 2,
    value: 'breakdown',
    name: 'Full breakdown',
  },
];

const REPORTING_PAGE_CONSTANTS = Object.freeze({
  pageSize: 10,
  pageTitle: PAGE_TITLE,
  tableSelectionItems: TABLE_SELECTION_ITEMS,
  viewSelectionItems: VIEW_SELECTION_ITEMS,
});

export { REPORTING_PAGE_CONSTANTS };
